import React from "react"
import { useSelector } from "react-redux"

import { UserIcon } from "client/components"
import { StoreType } from "client/store"
import {
    SidebarColumn,
    SidebarColumnHeader,
    SidebarContent,
} from "client/parts/layout"
import SidebarHelp from "client/parts/sidebarHelp"

const Sidebar = () => {
    const onlineUsers = useSelector((state: StoreType) => state.user.onlineUsers)
    const userList = useSelector((state: StoreType) => state.user.userList)

    return (
        <SidebarColumn>
            <SidebarColumnHeader>
                <SidebarHelp />
            </SidebarColumnHeader>
            <SidebarContent>
                {
                    Object.values(onlineUsers).map((userId: number) => (
                        <UserIcon
                            key={userId}
                            user={userList[userId]}
                            showName={false}
                            showProjectStatus={false}
                        />
                    ))
                }
            </SidebarContent>
        </SidebarColumn>
    )
}
export default Sidebar
